import { useState } from "react";

export const useTooltip = () => {
  const [container, setContainer] = useState<HTMLElement | null>(null);
  return { containerRef: setContainer, target: container };
};
